<template>
  <div class="rule">
    <div class="grey-block">
      <div class="container">
        <RulesContent>
          <template #top>
            <h2 class="title">Примеры оформления внутри ТЦ</h2>
            <SurveyNumbers :config="config">
              <template #title>
                <h3 class="title">
                  Данная зона <span>ОБЯЗАТЕЛЬНО</span> должна быть оформлена как
                  минимум одним POSM из ниже перечисленных:
                </h3>
              </template>
              <template #info>
                <p class="container__text link-m">
                  <strong>Дополнительно могут быть использованы POSm:</strong>
                </p>
                <ul>
                  <li>Напольный навигационный стикер</li>
                  <li>Павильонная лента</li>
                  <li>Открыто/Закрыто</li>
                  <li>От себя/На себя</li>
                </ul>
                <p class="container__text link-m">
                  <!-- Расширенный список POSm для оформления точки продаж можно
              посмотреть в
              <router-link to="/" class="link link--blue"
                >Каталоге POSm</router-link
              > -->
                  Расширенный список POSm для оформления точки продаж можно
                  посмотреть в Каталоге POSm
                </p>
              </template>
            </SurveyNumbers>
          </template>
          <template #bottom>
            <h2 class="title">Правила оформления внутри ТЦ</h2>
            <p class="container__text--big link-m">
              Если торговая точка распологается внутри ТЦ/павильона, то
              необходимо оформить внутреннюю навигацию к точке, например
              разместить напольные/настенные стикеры и подвесные/настенные
              таблички. Навигация внутри необходима для того, чтобы клиент с
              легкостью нашел точку продаж Tele2.
            </p>
            <div class="white-content">
              <div class="grid align-center">
                <div class="grey">
                  <BeforeAfter
                    before="before-2.png"
                    after="after-2.png"
                    offset="0.8"
                  />
                </div>
                <div>
                  <p class="container__text">
                    <strong
                      >Размещая внутреннюю навигацию необходимо помнить о
                      правилах:</strong
                    >
                  </p>
                  <AttentionIcon
                    class="m24"
                    :icon="{ name: 'back.svg', w: 20, h: 16 }"
                    text="Навигация должна находиться по ходу потока клиентов."
                  />
                  <AttentionIcon
                    class="m24"
                    :icon="{ name: 'eye.svg', w: 25, h: 19 }"
                    text="Навигация должна размещаться в «горячих» зонах на уровне глаз (~1,6-1,8 м от пола), т.е. места, где клиент обратит на них внимание."
                  />
                  <AttentionIcon :icon="{ name: 'sheets.svg', w: 23, h: 24 }">
                    <template #text>
                      <p class="container__text">
                        Нельзя допускать
                        <router-link to="/rules?rule=1" class="link link--blue"
                          >«эффект маскарада»</router-link
                        >
                      </p>
                    </template>
                  </AttentionIcon>
                </div>
              </div>
            </div>
          </template>
        </RulesContent>
        <h1 class="title">Зонирование торговых точек</h1>
        <ButtonLink
          :button="{ name: 'Входная группа', path: '/zones?zone=pink' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AttentionIcon from "../AttentionIcon.vue";
import BeforeAfter from "../BeforeAfter.vue";
import ButtonLink from "../ButtonLink.vue";
import RulesContent from "../RulesContent.vue";
import SurveyNumbers from "../SurveyNumbers.vue";

export default {
  components: {
    RulesContent,
    AttentionIcon,
    ButtonLink,
    SurveyNumbers,
    BeforeAfter,
  },
  name: "InternalDesign",
  data() {
    return {
      config: {
        img: "rule-3.png",
        buttons: [
          {
            bg: "#EC6430",
            number: 1,
            left: 19,
            top: 35,
            flag: "Навигационная табличка/стикер со стрелкой",
          },
          {
            bg: "#FF59A3",
            number: 2,
            left: 57,
            top: 19,
            flag: "Флаг фасадный",
          },
        ],
        points: [
          {
            bg: "#EC6430",
            number: 1,
            link: true,
            text: "Навигационная табличка/стикер со стрелкой",
          },
          {
            bg: "#FF59A3",
            number: 2,
            link: true,
            text: "Флаг фасадный",
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.rule {
  .grey-block {
    padding-bottom: 64px;
    @include tablet {
      padding-bottom: 24px;
    }
  }
  h2.title {
    margin-bottom: 32px;
    @include tablet {
      display: none;
    }
  }
  .white-content {
    padding: 24px;
    background: #ffffff;
    margin-top: 32px;
    img.bs {
      box-shadow: 0px 5px 16px rgba(34, 47, 82, 0.12);
      border-radius: 4px;
    }
    @include tablet {
      margin-top: 24px;
      padding: 0;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 60px;
    @include tablet {
      grid-template-columns: 1fr;
      grid-gap: 16px;
      padding-bottom: 24px;
    }
    &.align-center {
      align-items: center;
    }
    .m24 {
      margin: 24px 0;
      @include tablet {
        margin: 16px 0;
      }
    }
  }
  h3.title {
    font-family: var(--fontSerif);
    font-size: 20px;
    line-height: 120%;
    margin-bottom: 16px;
    @include tablet {
      font-size: 18px;
      line-height: 140%;
    }
    span {
      color: #ff59a3;
    }
  }
  .link-m.container__text {
    margin: 32px 0 8px 0;
    @include tablet {
      margin: 24px 0 8px 0;
    }
    a {
      font-size: 16px;
    }
  }
  h1.title {
    font-family: var(--fontStencil);
    font-size: 24px;
    line-height: 120%;
    text-transform: uppercase;
    margin-top: 56px;
    margin-bottom: 16px;
    @include tablet {
      margin-top: 24px;
      font-size: 20px;
      line-height: 120%;
    }
  }
  .button-link {
    max-width: 252px;
    @include onlyMobile {
      max-width: 100%;
    }
  }
  .grey {
    @include tablet {
      margin: 0 -15px;
      padding: 18px 15px 18px 15px;
      background: #f0f1f2;
    }
  }
}
</style>
